<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>VÉRIFICATION DE L'EMAIL ÉCHOUÉE</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>VÉRIFICATION DE L'EMAIL ÉCHOUÉE</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="post-job-area pt-5 pb-100 mt-5">
    <div class="container text-left">
        <img src="assets/guides/02.png" alt="" width="150" />
        <div class="pt-5">
            <h4>Échec de la Vérification de l'Email</h4>
            <h5>Cher(e) fournisseur,</h5>
            <p>
                La vérification de votre adresse email a échoué. Le lien de vérification peut être invalide ou avoir expiré.
            </p>
            <p>
                Veuillez vérifier que vous avez utilisé le lien le plus récent que nous vous avons envoyé par email,
                ou demander un nouveau lien de vérification.
            </p>
            <p>
                Si le problème persiste, veuillez contacter notre équipe de support pour obtenir de l'aide.
            </p>
            <p>Cordialement,</p>
            <p>L'équipe de support de la Bourse des Sous-Traitance et de Partenariats</p>
            <div class="pt-100">
                <button routerLink="/contact" class="btn btn-outline-main" type="button">
                    Contacter le support <i class="icofont-arrow-right"></i>
                </button>
                <!-- <button routerLink="/resend-verification" class="btn btn-outline-secondary ml-3" type="submit">
                    Renvoyer le lien <i class="icofont-refresh"></i>
                </button> -->
            </div>
        </div>
    </div>
</div>